import { ReactElement, useState } from "react";
import AlreadyWallet from "../components/NoviceFlow/AlreadyWallet";
import CoinbaseAdd from "../components/NoviceFlow/Coinbase/CoinbaseAdd";
import CoinbaseCreate from "../components/NoviceFlow/Coinbase/CoinbaseCreate";
import CreateWallet from "../components/NoviceFlow/CreateWallet";

import InitialScreen from "../components/NoviceFlow/initial";
import MetamaskAdd from "../components/NoviceFlow/Metamask/MetaMaskAdd";
import MetamaskCreate from "../components/NoviceFlow/Metamask/MetamaskCreate";
import Success from "../components/NoviceFlow/Success";

import MintLayout from "../components/Layouts/Mint";
import SEO from "../components/Seo/Seo";

export type FlowStates =
  | "initial"
  | "createWalletIntro"
  | "alreadyWalletIntro"
  | "metamaskCreate"
  | "coinbaseCreate"
  | "metamaskAdd"
  | "coinbaseAdd"
  | "success";

const NoviceMintFlow = () => {
  const [flow, setFlow] = useState<{
    prev: FlowStates | null;
    current: FlowStates;
  }>({ prev: null, current: "initial" });

  const renderContent = () => {
    if (flow.current === "initial") {
      return (
        <InitialScreen
          onClick={() =>
            setFlow({
              prev: "initial",
              current: "alreadyWalletIntro"
            })
          }
        />
      );
    }
    if (flow.current === "alreadyWalletIntro") {
      return (
        <AlreadyWallet
          onClickMeta={() =>
            setFlow({ prev: "alreadyWalletIntro", current: "metamaskAdd" })
          }
          onClickCb={() =>
            setFlow({ prev: "alreadyWalletIntro", current: "coinbaseAdd" })
          }
          onClickNo={() =>
            setFlow({
              prev: "alreadyWalletIntro",
              current: "createWalletIntro"
            })
          }
        />
      );
    }
    if (flow.current === "createWalletIntro") {
      return (
        <CreateWallet
          onClickMeta={() =>
            setFlow({ prev: "createWalletIntro", current: "metamaskCreate" })
          }
          onClickCb={() =>
            setFlow({ prev: "createWalletIntro", current: "coinbaseCreate" })
          }
        />
      );
    }
    if (flow.current === "metamaskCreate") {
      return <MetamaskCreate prevState={flow.prev} setFlowState={setFlow} />;
    }
    if (flow.current === "coinbaseCreate") {
      return <CoinbaseCreate prevState={flow.prev} setFlowState={setFlow} />;
    }
    if (flow.current === "coinbaseAdd") {
      return <CoinbaseAdd prevState={flow.prev} setFlowState={setFlow} />;
    }
    if (flow.current === "metamaskAdd") {
      return <MetamaskAdd prevState={flow.prev} setFlowState={setFlow} />;
    }
    if (flow.current === "success") {
      return <Success prevState={flow.prev} setFlowState={setFlow} />;
    }
    return null;
  };

  return (
    <>
      <SEO title="Novice Mint | Coinage Media" />
      <section className="flex flex-col mb-[80px]">{renderContent()}</section>
    </>
  );
};

NoviceMintFlow.getLayout = function getLayout(page: ReactElement) {
  return (
    <MintLayout hideMenu showExitInsteadOfConnect>
      {page}
    </MintLayout>
  );
};

export default NoviceMintFlow;
